module.exports = __webpack_public_path__ + "img/userD03.8b5faf47.jpg";